/**
 * type of target that annotation apply to.
 * This is used to apply correct decoration to a draft comment
 */

/**
 * The source of draft comment being created
 */

export var AnnotationSelectionType = /*#__PURE__*/function (AnnotationSelectionType) {
  AnnotationSelectionType["INVALID"] = "invalid";
  // Annotation should not be created, toolbar should not be shown
  AnnotationSelectionType["DISABLED"] = "disabled";
  // Annotation should not be created, toolbar should be shown, but disabled
  AnnotationSelectionType["VALID"] = "valid"; // Annotation can be created
  return AnnotationSelectionType;
}({});
var prefix = 'ak-editor-annotation';
export var AnnotationTestIds = {
  prefix: prefix,
  floatingComponent: "".concat(prefix, "-floating-component"),
  floatingToolbarCreateButton: "".concat(prefix, "-toolbar-create-button"),
  componentSave: "".concat(prefix, "-dummy-save-button"),
  componentClose: "".concat(prefix, "-dummy-close-button")
};

/**
 * Alternative to SelectInlineCommentCompoundExperience, used for the annotation plugin options
 * in the confluence editor presets. See createFullPageEditorPreset.ts or annotationPluginOptions.ts for usage.
 */